import { render, staticRenderFns } from "./DingYangArticle.vue?vue&type=template&id=65133a7d&scoped=true&"
import script from "./DingYangArticle.vue?vue&type=script&lang=js&"
export * from "./DingYangArticle.vue?vue&type=script&lang=js&"
import style0 from "./DingYangArticle.vue?vue&type=style&index=0&id=65133a7d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65133a7d",
  null
  
)

export default component.exports